'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiInputCheckedOutline = function TiInputCheckedOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm33.1 10.3c-0.3-1.3-1.2-2.4-2.3-3-0.8-0.4-1.6-0.6-2.5-0.6-1.4 0-2.7 0.6-3.7 1.6h-11.3c-2.7 0-5 2.3-5 5v13.4c0 2.7 2.3 5 5 5h13.4c2.7 0 5-2.3 5-5v-10.8l1-1.8c0.7-1.2 0.8-2.5 0.4-3.8z m-6.2 0.6c0.2-0.4 0.4-0.6 0.7-0.7 0.5-0.2 1.1-0.2 1.5 0 0.4 0.2 0.7 0.6 0.8 1 0.1 0.2 0.1 0.4 0.1 0.6 0 0.2-0.1 0.4-0.2 0.6 0 0 0 0 0 0.1l-6.7 11.6c-0.2 0.5-0.7 0.8-1.2 0.9-0.1 0-0.2 0-0.2 0-0.5 0-0.9-0.2-1.2-0.5l-5-5c-0.7-0.6-0.7-1.7 0-2.3 0.3-0.4 0.7-0.5 1.2-0.5s0.8 0.1 1.1 0.5l3.5 3.4 5.6-9.7z m-0.2 17.4h-13.4c-0.9 0-1.6-0.7-1.6-1.6v-13.4c0-0.9 0.7-1.6 1.6-1.6h11.2l-3.6 6.2-1.9-1.9c-0.6-0.7-1.5-1-2.3-1s-1.7 0.3-2.4 1c-1.3 1.3-1.3 3.4 0 4.7l5 5c0.6 0.6 1.5 1 2.4 1 0.1 0 0.3 0 0.4-0.1 1.1-0.1 2-0.7 2.5-1.6l3.7-6.6v8.3c0 0.9-0.7 1.6-1.6 1.6z' })
        )
    );
};

exports.default = TiInputCheckedOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/input-checked-outline.js
// module id = 1921
// module chunks = 0